var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../../helpers/custom-prop-types';
import Select2MultipleInputOnlyOption from '../../../../Ui/Common/Fields/Select2MultipleInputOnly/Select2MultipleInputOnlyOption';
import Image from '../../../../Ui/Common/Image';
const ActionShareMemberOption = (props) => {
    const { data } = props, otherProps = __rest(props, ["data"]);
    const { __isNew__: isNew, email, firstName, lastName, photo, value } = data;
    return (_jsx(Select2MultipleInputOnlyOption, Object.assign({ data: data }, otherProps, { children: _jsx("div", Object.assign({ className: 'proffit_search_action_share_member_select_option' }, { children: isNew ? (_jsx("div", Object.assign({ className: 'member_add pointer' }, { children: _jsx("div", Object.assign({ className: 'add_text' }, { children: `追加：${value}` })) }))) : (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: 'member_left' }, { children: _jsx("div", Object.assign({ className: 'left_thumbnail' }, { children: _jsx(Image, { alt: '', isObjectFit: true, noImageType: 'user', src: photo }) })) })), _jsxs("div", Object.assign({ className: 'member_right' }, { children: [_jsx("div", Object.assign({ className: 'right_name' }, { children: `${lastName} ${firstName}` })), _jsx("div", Object.assign({ className: 'right_email' }, { children: email }))] }))] })) })) })));
};
ActionShareMemberOption.propTypes = {
    data: propShape().isRequired,
};
export default ActionShareMemberOption;
